import { applyPromoOverride } from 'yoda-core-components/lib/helpers/Stylitics';
import get from 'lodash/get';
import { miniPDPOnShopTheSetOpen } from 'yoda-site-components/lib/actions/MiniPDPAction';
import { shopTheSetLoadSuccess, shopTheSetClickEvent } from '../../../actions/AnalyticsAction';

let _onOutfitsLoaded = null;
let _onItemClick = null;
let _lastClickPosition = 0;

const shopTheSetConfig = {
    id: 'shop-the-set',
    containerId: 'shopSetContainer',
    title: 'Shop The Set',
    titleId: 'widget-title-STS',
    featureFlagKey: 'enableShopTheSet',
    imageQuery: '.stylitics-ui-image',

    getScriptURL: (prefs) => get(prefs, 'styliticsWidget.scriptURL', ''),

    createWidget: async (itemNumber) => {
        if (typeof StyliticsComposer === 'undefined') {
            throw new Error('StyliticsComposer is not available');
        }
        return StyliticsComposer.initialize({
            client: 'jcpenney_intimates_matching_sets',
            target: 'shopSetContainer',
            config: {
                modules: [
                    {
                        type: 'shop-the-set',
                        params: {
                            api: { min: 3, max: 10, item_number: itemNumber },
                            text: {
                                viewDetailsCTA: 'Shop The Set',
                                itemLinkCTA: 'Shop',
                            },
                        },
                        on: {
                            'mount.set': ({ items }) => {
                                _onOutfitsLoaded?.(items);
                                // Apply promo to details section after widget renders
                                setTimeout(() => {
                                    const container = document.getElementById('shopSetContainer');
                                    if (!container) return;
                                    // Find all details sections with sale prices
                                    container
                                        .querySelectorAll(
                                            '.stylitics-ms-set-item-details .stylitics-ui-sale-price:not(.promotional-sale-price)'
                                        )
                                        .forEach((saleEl) => {
                                            if (!saleEl.querySelector('.promotional-text')) {
                                                const span = document.createElement('span');
                                                span.className = 'promotional-text';
                                                span.textContent = ' with code';
                                                saleEl.classList.add('promotional-sale-price');
                                                saleEl.append(span);
                                            }
                                        });
                                }, 500);
                            },
                            'mount.item': ({ item, element }) => {
                                applyPromoOverride(element, item);
                            },
                        },
                        override: {
                            'click.item': (data) => {
                                const item = data?.item;
                                const outfit = data?.outfit || {};
                                const position = (outfit?.items || []).findIndex(
                                    (i) => i.item_id === item?.item_id
                                );
                                _lastClickPosition = position >= 0 ? position : 0;
                                _onItemClick?.(item, outfit);
                            },
                        },
                    },
                ],
            },
        });
    },

    registerEvents: (instance, { onOutfitsLoaded, onItemClick }) => {
        _onOutfitsLoaded = onOutfitsLoaded;
        _onItemClick = onItemClick;
    },

    refresh: (instance, itemNumber) => {
        instance?.refresh?.({ sharedParams: { api: { item_number: itemNumber } } });
    },

    analyticsLoadAction: shopTheSetLoadSuccess,
    analyticsClickAction: ({ id, ppId }) =>
        shopTheSetClickEvent({
            shopTheSetID: id?.toString() || '',
            shopTheSetPPID: ppId,
            moduleName: 'shop the set',
            linkText: 'Shop',
            linkPosition: _lastClickPosition,
        }),
    miniPDPAction: miniPDPOnShopTheSetOpen,
    analyticsModule: 'shop the set',
};

export default shopTheSetConfig;
